// Blueprint payload envelopes are keyed one of two ways: `id` when the
// envelope names a record that already exists, and `lid` when the blueprint
// creates the record on apply. The applicator keeps those two namespaces
// separate, so a relationship pointer has to name its target under the same
// key the target envelope used -- pointing at an lid-keyed envelope by `id`
// resolves to nothing and the whole item is skipped.
//
// The editor's local state collapses both into one opaque string
// (`String(e.id ?? e.lid)`), so the key has to be recovered from the payload
// at write time. An lid is also an opaque token, never a number: coercing a
// uuid lid with Number() yields NaN, which serializes to null and destroys
// the pointer outright.

type Envelope = { type?: string; id?: string | number; lid?: string | number };

type Pointer = {
  data: { id: string; type: string } | { lid: string; type: string } | null;
};

export const pointerTo = (
  envelopes: Envelope[],
  type: string,
  token: string | number | null | undefined
): Pointer => {
  if (token === null || token === undefined || token === "") {
    return { data: null };
  }

  const key = String(token);
  const target = envelopes.find(
    (e) => e.type === type && String(e.id ?? e.lid) === key
  );

  return target && target.id === undefined
    ? { data: { lid: key, type } }
    : { data: { id: key, type } };
};
